import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

type CatalogueTabProps = {
    initialTab: number;
};
const CatalogueTab = ({ initialTab }: CatalogueTabProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    

    const [tabIndex, setTabIndex] = useState(initialTab);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabIndex(newValue);
        // newValue による条件分岐で URL を更新
        if (newValue === 0) {
            navigate('/catalogue/search', { replace: true });
        } else {
            navigate('/catalogue/disease', { replace: true });
        }
    };

    useEffect(() => {
        setTabIndex(initialTab);
    }, [initialTab]);

    return (
        <Box>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                    sx: { width: 'auto' } // インジケーターを文字幅に合わせる
                }}
            >
                <Tab label="検索" sx={{ fontSize: 20}}/>
                <Tab label="疾患一覧" sx={{ fontSize: 20}}/>
            </Tabs>

        </Box>
    );
};

export default CatalogueTab;
